<template>
  <div id="nav-nav" class="nav-parent s-no-select" :class="[{'hidden': navHidden }, {'links-hidden' : linksHidden}]">
    <nav>
      <router-link class="nav-homelogo" to="/">
        <img src="@/assets/images/Nav_Logo_WHT_SVG.svg" alt="" align="left" class="nav-logo s-hide-lg">
        <img src="@/assets/images/Nav_Logo_Icon_WHT_SVG.svg" alt="" align="left" class="nav-logo-icon s-show-md">
      </router-link>

      <img @click="toggleMenu" src="@/assets/images/Nav_Btn_SVG.svg" alt="" align="Right" class="nav-button-toggle"
           v-if="linksHidden">
      <img @click="toggleMenu" src="@/assets/images/nav_btn_close.svg" alt="" align="Right" class="nav-button-toggle"
           v-if="!linksHidden">

      <div @click="dropdownShown = !dropdownShown" class="nav-dropdown-parent" :class="[{'selected' : dropdownShown}]">

        <span class=""><s-icon icon-font="s-icon-language"/>{{languageSelected}}</span>
        <transition name="t-fade-expand">

          <div v-show="dropdownShown" class="nav-dropdown-child">
            <span @click="languageSelected = 'EN'" :class="[{'selected' : languageSelected == 'EN'}]">{{ $t('nav.language.en') }}</span>
            <span @click="languageSelected = 'ES'" :class="[{'selected' : languageSelected == 'ES'}]">{{ $t('nav.language.es') }}</span>
            <span @click="languageSelected = 'PT'" :class="[{'selected' : languageSelected == 'PT'}]">{{ $t('nav.language.pt') }}</span>
            <span @click="languageSelected = 'DE'" :class="[{'selected' : languageSelected == 'DE'}]">{{ $t('nav.language.de') }}</span>
            <span @click="languageSelected = 'FR'" :class="[{'selected' : languageSelected == 'FR'}]">{{ $t('nav.language.fr') }}</span>
            <span @click="languageSelected = 'HI'" :class="[{'selected' : languageSelected == 'HO'}]">{{ $t('nav.language.hi') }}</span>
          </div>
        </transition>
      </div>
      <hr class="s-hr-vertical-white s-hide-sm">

      <router-link class="nav-link hvr-fade" to="/pricing">{{ $t('nav.pricing-link') }}</router-link>
      <!-- TODO: change $t names and router-link to paths once you have those pages done -->
      <a class="nav-products-parent nav-link hvr-fade"
         :class="[{'router-link-exact-active' : $router.currentRoute.path === '/products-files'},
                  {'router-link-exact-active' : $router.currentRoute.path === '/products-cloud'},
                  {'router-link-exact-active' : $router.currentRoute.path === '/products-search'}]">
        <span>{{ $t('nav.products-dropdown') }}</span>
        <div class="nav-products-child">
          <div>
            <router-link to="/products-files"><img src="@/assets/images/icon_products_files.svg" alt="">{{ $t('nav.products-a') }}</router-link>
            <router-link to="/products-cloud"><img src="@/assets/images/icon_products_cloud.svg" alt="">{{ $t('nav.products-b') }}</router-link>
            <router-link to="/products-search"><img src="@/assets/images/icon_products_search_3.svg" alt="">{{ $t('nav.products-c') }}</router-link>
          </div>
        </div>
      </a>

      <a href="https://chrome.google.com/webstore/detail/seedr/abfimpkhacgimamjbiegeoponlepcbob"
         class="nav-link hvr-fade">{{ $t('nav.extension-link') }}</a>

      <a @click="navActions = 'login'" class="nav-link hvr-fade s-pointer">{{ $t('actions.login') }}</a>
      <s-button class="button-nav" btn-link="/signup">{{$t('actions.try-now')}}</s-button>

    </nav>
  </div>
<!--  <Teleport to="#modals">-->
    <transition name="t-backdrop">
      <section class="s-modal-backdrop-container" v-if="navActions === 'login'">
        <s-modal
              modal-type="login"
              @click-leave="navActions = ''"
              @click-close="navActions = ''"
              @click-confirm="navActions = ''"
          ></s-modal>
      </section>
    </transition>
<!--  </Teleport>-->
</template>

<script>

import SIcon from '@/components/SIcon.vue'
import SButton from "@/components/SButton.vue";
import SModal from "@/components/SModal.vue";

export default {
  name: 'Nav',
  components: {
    SModal,
    SButton,
    SIcon
  },
  props: {
    msg: String
  },
  data () {
    return {
      navHidden: false,
      linksHidden: true,
      dropdownShown: false,
      languageSelected: 'EN',
      navActions: ''
    }
  },
  methods: {
    toggleMenu (forceHide) {
      this.linksHidden = (!this.linksHidden || (forceHide === true))
    },
    openLogin() {

    }
  },
  watch: {
    $route (to, from) {
      this.toggleMenu(true)

      const hideNavPages = [] // page paths where the top nav is hidden
      if (hideNavPages.includes(to.path)) {
        this.navHidden = true
      }
    }
  },
  mounted: function() {
    window.seedrLoggedIn = function (data, type, windowName) {
      // redirect to /app
      window.location.href = '/app/files/0'
    }
  }
}
</script>
